export const OWNERS = 'owners';
export const OWNER_ID = 'ownerId';
export const PERIOD = 'period';
export const PERIOD_START_DATE = 'startDate';
export const CAMPAIGN_IDS = 'campaignIds';
export const CAMPAIGN_NAMES = 'campaignNames'; // just for a view
